import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import {
    dataPointersUpdate,
    removeDataPointers,
} from '~SpectateStore/actions/dataPointersActions';
import { marketSwitcherUpdate } from '~SpectateStore/actions/marketSwitcherUpdate';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';

export const SLICE_NAME = 'dataPointers';

export const dataPointersAdapter = createEntityAdapter();

const dataPointersSlice = createSlice({
    name: SLICE_NAME,
    initialState: dataPointersAdapter.getInitialState(),
    reducers: {
        addDataPointers: dataPointersAdapter.addOne,
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                dataPointersUpdate,
                (state, { payload : { dataPointers = {} } }) => {
                    if (Object.keys(dataPointers).length > 0) {
                        return dataPointersAdapter.setOne(state, dataPointers);
                    }

                    return state;
                },
            )
            .addCase(
                removeDataPointers,
                (state, { payload: dataPointersId }) => {
                    return dataPointersAdapter.removeOne(state, dataPointersId);
                },
            )
            .addCase(
                marketSwitcherUpdate,
                (state, { payload: { dataPointers } }) => {
                    const { id, pointers } = dataPointers;
                    // Updates only the pointers, keeping the existing order of events
                    dataPointersAdapter.updateOne(state, {
                        id,
                        changes: {
                            pointers,
                        },
                    });
                }
            )
            .addCase(
                eventInplayStart,
                (state, { payload : { dataPointers } }) => {
                    Object.entries(dataPointers).forEach(([entityId, data]) => {
                        const { eventOrder, pointers } = data;

                        dataPointersAdapter.updateOne(state, {
                            id: entityId,
                            changes: {
                                eventOrder,
                                pointers,
                            },
                        });
                    });
                },
            );
    },
});

export default dataPointersSlice.reducer;
